import React from 'react';
import './AboutVBUSection.css';

function AboutVBUSection() {
  return (
    <div className="AboutVBUSectionContainer">
      <div className="VCDeskSection" data-aos="fade-up">
        <div className="VCDeskImageWrapper">
          <img src="https://www.vbu.ac.in/resources/assets/images/dr_chandra.jpg" alt="VC Profile" />
        </div>
        <div className="VCDeskContent">
          <h2>From VC's Desk</h2>
          <p className="VCSignature">Prof. (Dr.) Chandra Bhushan Sharma</p>
        </div>
      </div>

      <div className="AboutVBUContentSection" data-aos="fade-up">
        <div className="AboutVBULeft">
          <h2>About <span>VBU</span></h2>
          <p>
            Vinoba Bhave University was established in the year 1992 with its headquarter at Hazaribag, the divisional headquarter of North Chhotanagpur division of the state of JHARKHAND. It is situated at a distance of 100 K.M. from Ranchi, The capital of Jharkhand. Vinoba Bhave University is imparting post-graduate teaching and research in Physical Science, Life Science, Earth Science, Social Science, Humanities, Commerce, Technology and Medical Science.
          </p>
          <a href="https://www.vbu.ac.in/about_us" target="_blank" rel="noopener noreferrer" className="ReadMoreBtn">Read more</a>
        </div>
        <div className="AboutVBURight">
          <img src="https://www.vbu.ac.in/resources/assets/images/aboutimg.jpg" alt="VBU Gate" />
        </div>
      </div>
    </div>
  );
}

export default AboutVBUSection;
